import { useMutation } from '@tanstack/react-query';
import { PUBLIC_API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';

const mutationFn = async ({ token, assignment_uuid }) => {
  const url = `public/${token}/roleplay/${assignment_uuid}/submit/`;
  const { data } = await PUBLIC_API.post(url);
  return data;
};

const useSubmitPublicAssignmentMutation = () => {
  return useMutation({
    mutationFn,
    onSuccess: (response) => {
      toastFlashMessage(response?.message, 'success');
    },
  });
};

export default useSubmitPublicAssignmentMutation;
